<template>
  <div id="app" class="payment-container">
    <form id="payment-form" @submit.prevent="handleSubmit">
      <label for="card-element">信用卡信息</label>
      <div id="card-element" class="card-element"></div>

      <div id="card-errors" class="card-errors" role="alert"></div>

      <button type="submit" class="submit-button">支付 ¥50.00</button>
    </form>
  </div>
</template>

<script>
import request from "superagent";

export default {
  data() {
    return {
      stripe: null,
      cardElement: null,
    };
  },
  mounted() {
    this.stripe = Stripe(
      "pk_test_51RgISo2M29q2sv4pqdJESLmcUeSn6kl55jWnPLqEdJ9vvP4uQ0jWjI3N82QP6aYKgXr9eYWumTSalnzGpCcBA2fR00BymQITb5"
    );
    const elements = this.stripe.elements();
    this.cardElement = elements.create("card", {
      style: {
        base: {
          fontSize: "16px",
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          "::placeholder": {
            color: "#aab7c4",
          },
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      },
    });
    this.cardElement.mount("#card-element");
  },
  methods: {
    async handleSubmit() {
      const { paymentMethod, error } = await this.stripe.createPaymentMethod({
        type: "card",
        card: this.cardElement,
      });

      if (error) {
        document.getElementById("card-errors").textContent = error.message;
      } else {
        // 将 paymentMethod.id 发送给后端
        request
          .post("http://localhost:18080/api/pay")
          .send({
            paymentMethodId: paymentMethod.id,
            amount: 50000, // 金额单位是分，5000 表示 50.00
          })
          .end((err, res) => {
            if (err) {
              alert("支付失败: " + err.message);
            } else {
              alert("支付结果: " + res.body.message || "成功");
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.payment-container {
  max-width: 400px;
  margin: 60px auto;
  padding: 30px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fafafa;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

#payment-form {
  display: flex;
  flex-direction: column;
}

label {
  font-weight: bold;
  margin-bottom: 10px;
}

.card-element {
  padding: 10px;
  border: 1px solid #cfd7df;
  border-radius: 4px;
  margin-bottom: 20px;
  background-color: white;
}

.card-errors {
  color: red;
  margin-bottom: 20px;
  min-height: 20px;
}

.submit-button {
  background-color: #5469d4;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: background-color 0.3s;
}

.submit-button:hover {
  background-color: #4254a5;
}
</style>



// WEBPACK FOOTER //
// src/components/content/product/stripe.vue